// Note: Appointment url should start with https://
export default {
  'matlab': {
    'name': 'MATLAB',
    'class': 'CS9A',
    'piazza': ' https://piazza.com/berkeley/fall2018/cs9aselfpaced?token=fZtKqHrKAmM',
    'appointment': 'https://selfpacematlab.youcanbook.me/'
  },
  'c': {
    'name': 'C',
    'class': 'CS9C',
    'piazza': 'http://piazza.com/berkeley/spring2019/9cselfpaced?token=iGnnaEkL4Pl',
    'appointment': 'https://selfpacec.youcanbook.me'
  },
  'unix': {
    'name': 'UNIX',
    'class': 'CS9E',
    'piazza': 'http://piazza.com/berkeley/spring2019/cs9eselfpaced?token=iGnnaEkL4Pl',
    'appointment': 'https://selfpaceunix.youcanbook.me'
  },
  'cpp': {
    'name': 'C++',
    'class': 'CS9F',
    'piazza': 'http://piazza.com/berkeley/spring2019/cs9fselfpaced?token=iGnnaEkL4Pl',
    'appointment': 'https://selfpacecpp.youcanbook.me'
  },
  'java': {
    'name': 'Java',
    'class': 'CS9G',
    'piazza': 'http://piazza.com/berkeley/spring2019/cs9gselfpaced?token=iGnnaEkL4Pl',
    'appointment': 'https://selfpacejava.youcanbook.me'
  },
  'python': {
    'name': 'Python',
    'class': 'CS9H',
    'piazza': 'http://piazza.com/berkeley/spring2019/compsci9h?token=iGnnaEkL4Pl',
    'appointment': 'https://selfpacepython.youcanbook.me'
  },
  '47b': {
    'name': '47B',
    'class': 'CS47B',
    'piazza': 'https://piazza.com/berkeley/fall2018/compsci47b?token=fZtKqHrKAmM',
    'appointment': 'https://selfpace47b.youcanbook.me'
  }
}



// WEBPACK FOOTER //
// ./src/components/courses/settings.js